import React, { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";
import './CanliYayinPage.scss';

const CanliYayinPage = () => {
    const playerWrapperRef = useRef(null);
    const playerRef = useRef(null);
    const [muted, setMuted] = useState(true);
    const [playing, setPlaying] = useState(true);

    // toast state
    const [toast, setToast] = useState(null); // { message, type }
    const toastTimerRef = useRef(null);

    const showToast = (message, type = 'info', duration = 4000) => {
        // clear previous
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ message, type });
        toastTimerRef.current = setTimeout(() => setToast(null), duration);
    };

    // cleanup toast timer on unmount
    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        };
    }, []);

    const toggleMute = () => setMuted(m => !m);
    const togglePlay = () => setPlaying(p => !p);

    const openFullscreen = () => {
        const el = playerWrapperRef.current;
        if (!el) return;
        if (el.requestFullscreen) el.requestFullscreen();
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
        else if (el.msRequestFullscreen) el.msRequestFullscreen();
    };

    // Cast to TV - best-effort using Remote Playback / Presentation API, with graceful fallback
    const castToTV = async () => {
        const streamUrl = 'https://api-tv33.yayin.com.tr/ordubeltv/video.m3u8';
        try {
            // 1) Try to get underlying media element from ReactPlayer
            const internal = playerRef.current && typeof playerRef.current.getInternalPlayer === 'function'
                ? playerRef.current.getInternalPlayer()
                : null;

            if (internal && typeof internal.requestRemotePlayback === 'function') {
                // Some browsers (Remote Playback API)
                await internal.requestRemotePlayback();
                showToast('Yansıtma başlatıldı (Remote Playback API). TV ile eşleşme ekranına bakın.', 'success');
                return;
            }

            // 2) Try Presentation API (requires a presentation receiver page on the TV)
            if (navigator.presentation && typeof navigator.presentation.requestSession === 'function') {
                // We pass the stream URL as the presentation URL — this works only if the receiver can play the stream directly.
                try {
                    await navigator.presentation.requestSession(streamUrl);
                    showToast('Presentation API isteği gönderildi. TV tarafında onaylayın.', 'success');
                    return;
                } catch (err) {
                    console.warn('Presentation API hatası:', err);
                    showToast('Presentation API ile bağlantı kurulamadı.', 'error');
                }
            }

            // 3) Fallback: open the stream in a new window so user can cast from browser/phone manually
            window.open(streamUrl, '_blank');
            showToast("Yeni pencerede yayın açıldı. TV'de paylaşım/ekran yansıtma kullanarak seçebilirsiniz.", 'info');
        } catch (err) {
            console.error('Cast hatası', err);
            showToast('Yansıtma başlatılamadı — tarayıcınız desteklemeyebilir.', 'error');
        }
    };

    return (
        <div className="canli-page-root">
            <div className="canli-container">

                <div className="page-title-wrap">
                    <h1 className="page-title">Canlı Yayın</h1>
                    <p className="page-sub">Anlık yayın akışı - canlı yayın izleniyor</p>
                </div>

                <section className="live-player-card">
                    <div className="player-meta">
                        <div className="meta-left">
                            <div className="live-badge">LIVE</div>
                            <div className="live-title">OBB TV - Canlı Yayın</div>
                        </div>
                        <div className="meta-actions">
                            <button className="btn small gradient" onClick={togglePlay}>{playing ? 'Durdur' : 'Oynat'}</button>
                            <button className="btn small outline" onClick={toggleMute}>{muted ? 'Sesi Aç' : 'Sesi Kapat'}</button>
                            <button className="btn small" onClick={castToTV}>TV'ye Yansıt</button>
                            <button className="btn small" onClick={openFullscreen}>Tam Ekran</button>
                        </div>
                    </div>

                    <div className="player-wrapper" ref={playerWrapperRef}>
                        {/* corner watermark */}
                        <div className="player-watermark">OBB TV</div>

                        <div className="react-player-outer">
                            <ReactPlayer
                                ref={playerRef}
                                className="react-player"
                                url='https://api-tv33.yayin.com.tr/ordubeltv/video.m3u8'
                                playing={playing}
                                controls={true} // Cast ikonu için genellikle gereklidir
                                muted={muted}
                                width="100%"
                                height="100%"
                                playsinline
                                config={{
                                    file: {
                                        forceHLS: true,
                                        attributes: {
                                            disableRemotePlayback: false, // Uzaktan oynatmayı engelleme
                                            "x-webkit-airplay": "allow"    // AirPlay desteği
                                        }
                                    }
                                }}
                            />
                        </div>

                        {/* subtle bottom fade overlay for better contrast */}
                        <div className="player-overlay-fade" aria-hidden="true"></div>
                    </div>

                </section>

                {/* Toast */}
                {toast && (
                    <div className={`canli-toast ${toast.type}`} role="status" aria-live="polite">
                        {toast.message}
                    </div>
                )}
             </div>
         </div>
     )
}

export default CanliYayinPage;